import { render, staticRenderFns } from "./ThemeSetup.vue?vue&type=template&id=2ee9de8a&scoped=true"
import script from "./ThemeSetup.vue?vue&type=script&lang=js"
export * from "./ThemeSetup.vue?vue&type=script&lang=js"
import style0 from "./ThemeSetup.vue?vue&type=style&index=0&id=2ee9de8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9de8a",
  null
  
)

export default component.exports